<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="temperatureCheckFileForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                temperatureCheckFileForm: () => import('../forms/TemperatureCheckFileForm'),
                headers: [
                    { text: 'Temperature Check', value: 'temperatureCheckId', table: 'temperatureChecks', form: () => import('../forms/TemperatureCheckForm') },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    files: [],
                    temperatureChecks: [],
                    items: []
                },
                sorting: [
                    { column: "temperatureCheckId", direction: "ascending" },
                    { column: "fileId", direction: "ascending" },
                ],
                itemsField: 'temperatureCheckFiles',
                editPageName: 'temperatureCheckFile',
                apiMethod: 'TemperatureCheckFiles',
                claimName: 'TemperatureCheckFiles',
                formTitle: 'Temperature Check File',
                excelTitle: 'Temperature Check Files',
                hasEditPage: false,
            }
        },
    };
</script>
